<template>

    <MenuIsoGrow/>

    <div class="px-6 surface-overlay relative">
        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Education</h3>

                </div>
            </div>
        </div>
    </div>

    <IsoGrowFooter/>

</template>

<script>
import IsoGrowFooter from "@/components/isogrow/IsoGrowFooter.vue";
import MenuIsoGrow from "@/components/isogrow/MenuIsoGrow.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";

export default {
    components: {
        MenuIsoGrow,
        IsoGrowFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;

        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] No user data found.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
        }
    },
    data() {

        return {
            activeTab: 1,
            items: [
                {
                    label: 'Options',
                    items: [
                        {label: 'Add New', icon: 'pi pi-fw pi-plus'},
                        {label: 'Search', icon: 'pi pi-fw pi-search'}
                    ]
                }
            ],
            date: new Date(),
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            profile: {},
        }
    },
    methods: {
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        previousDate() {
            this.date.setDate(this.date.getDate() - 1);
            this.date = new Date(this.date);
        },

        nextDate() {
            this.date.setDate(this.date.getDate() + 1);
            this.date = new Date(this.date);
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
